module.exports = __webpack_public_path__ + "img/user-pa.e5e152c4.svg";